import { render, staticRenderFns } from "./FooterMenuItemMob.vue?vue&type=template&id=41c2de2b&scoped=true"
import script from "./FooterMenuItemMob.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterMenuItemMob.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FooterMenuItemMob.vue?vue&type=style&index=0&id=41c2de2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c2de2b",
  null
  
)

export default component.exports